import { memoize } from 'lodash';
import { Component } from 'react';
import {
  IHandCard,
  IHiddenCard,
  IVisibleCard,
  PlayerHand,
} from '../../Models/CardModels';
import { IVisiblePlayer } from '../../Models/StateModels';
import { getCardSelection } from './cardSelection';
import HandCards, { sortByValueThenSuit } from './HandCards/HandCards';
import TableCards from './TableCards/TableCards';
import TableCardsInPlay from './TableCardsInPlay/TableCardsInPlay';

export interface IPlayerProps {
  player: IVisiblePlayer;
  handleError: (e: Error) => void;
  selectedCardIds: string[];
  rejectedCardIds: string[];
  onSelectionChange: (cardIds: string[]) => void;
  onReject: (cardIds: string[]) => void;
}

class Player extends Component<IPlayerProps> {
  public render() {
    const { player } = this.props;
    const { tableCards, handCards, hiddenCards } = getCards(player);
    const isTableInPlay =
      handCards.length === 0 &&
      (tableCards.length > 0 || hiddenCards.length > 0);
    const selection = getCardSelection({
      cards: selectableCards(handCards, tableCards, hiddenCards),
      availablePlays: player.availablePlays,
      isTurn: player.isTurn,
      selectedCardIds: this.props.selectedCardIds,
      rejectedCardIds: this.props.rejectedCardIds,
      onSelectionChange: this.props.onSelectionChange,
      onReject: this.props.onReject,
    });
    return (
      <div className="player flex flex-col items-center">
        {isTableInPlay ? (
          <TableCardsInPlay
            visibleCards={tableCards}
            hiddenCards={hiddenCards}
            selection={selection}
          />
        ) : (
          <>
            <TableCards
              visibleCards={tableCards}
              hiddenCards={hiddenCards}
              selection={selection}
            />
            <HandCards handCards={handCards} selection={selection} />
          </>
        )}
      </div>
    );
  }
}

export default Player;

function selectableCards(
  handCards: IHandCard[],
  tableCards: IVisibleCard[],
  hiddenCards: IHiddenCard[]
) {
  if (handCards.length > 0) {
    return [...sortByValueThenSuit(handCards), ...tableCards];
  }
  return tableCards.length > 0 ? tableCards : hiddenCards;
}

const getCards = memoize((player: IVisiblePlayer) => {
  const tableCards: IVisibleCard[] = player.visibleCards.map(
    (card) => ({ source: PlayerHand.VISIBLE, card }) as const
  );
  const handCards: IHandCard[] = player.handCards.map(
    (card) => ({ source: PlayerHand.HAND, card }) as const
  );
  const hiddenCards: IHiddenCard[] = player.hiddenCards.map(
    (card) => ({ source: PlayerHand.HIDDEN, card }) as const
  );
  return { tableCards, handCards, hiddenCards };
});
